import React, { useContext } from 'react';
import { Badge, Box, Menu, MenuItem, Divider, styled } from '@mui/material';
import { AppContext } from 'context';

const StyledBadge = styled(Badge)(({ theme }) => ({
	'& .MuiBadge-dot': {
		height: 10,
		width: 10,
		backgroundColor: theme.palette.success.main
	}
}));

const UserMenu = ({
	open,
	anchorEl,
	handleToggleMenu,
	handleLogoutClick,
	handleClick,
	...props
}) => {
	const { currentUser, authenticated } = useContext(AppContext);

	return (
		<Menu open={open} onClose={handleToggleMenu} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleClick(`/users/${currentUser.id}/edit`)}>
				My Account
			</MenuItem>
			<Divider />
			<MenuItem onClick={handleLogoutClick}>
				<StyledBadge
					variant="dot"
					overlap="rectangular"
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left'
					}}
				>
					<Box mx={1} />
				</StyledBadge>
				Sign Out
			</MenuItem>
		</Menu>
	);
};

export default UserMenu;
